<ion-footer class="ion-no-border">
  <ion-tab-bar>
    @for (tab of items; track tab.id) {
      <ion-tab-button
        [routerLink]="tab.url"
        routerDirection="root"
        [replaceUrl]="true"
        routerLinkActive="is-selected"
        [routerLinkActiveOptions]="{ exact: false }"
        #rla="routerLinkActive"
      >
        <span class="tab-icon-wrap">
          <ml-icon [class.is-selected]="rla.isActive" [name]="tab.icon" />
          @if (navBadges()[tab.id]; as badge) {
            <ion-badge
              class="tab-badge"
              [attr.aria-label]="'shell.menu.pendingNotificationsAria' | mlTranslate: { count: badge }"
            >
              {{ badge }}
            </ion-badge>
          }
        </span>
        <ion-label>{{ tab.labelKey | mlTranslate }}</ion-label>
      </ion-tab-button>
    }
  </ion-tab-bar>
</ion-footer>
